import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=58ee2f58&scoped=true&lang=pug&"
import script from "./Reserved.vue?vue&type=script&lang=js&"
export * from "./Reserved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee2f58",
  null
  
)

export default component.exports